var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AppSettings } from 'app/app.settings';
import { ActivityService } from './activity.service';
import { AppinfoService } from './appinfo.service';
import { AttrIndexService } from './attr-index.service';
import { CommonRequestService } from './common-request.service';
import { UserService } from './user.service';
import * as i0 from "@angular/core";
import * as i1 from "./activity.service";
import * as i2 from "./appinfo.service";
import * as i3 from "./attr-index.service";
import * as i4 from "./common-request.service";
import * as i5 from "./user.service";
var DomainService = /** @class */ (function () {
    // nenaDomains: NenaDomains = {}
    // placeNameDomains;
    // domainValueListByIndex: {
    // 	// For nena domain, idx is col_name
    // 	// For nct simple domain, idx is valueDomainNameNct
    // 	// For nct nested domain, idx is ...<grand parent valueDomainNameNct>-<grand parent value>-<parent valueDomainNameNcte>-<parent value>-<col name>
    // 	[idx: string]: any[];
    // } = {};
    // nestedNctNameRelationIndex: {
    // 	[nctName: string]: {
    // 		parent?: string; // direct parent nct_name
    // 		children?: string[]; // direct child nct_name
    // 	};
    // } = {};
    // indexSeparator = '-';
    function DomainService(activityService, appinfoService, attrIndexService, requestService, userService) {
        this.activityService = activityService;
        this.appinfoService = appinfoService;
        this.attrIndexService = attrIndexService;
        this.requestService = requestService;
        this.userService = userService;
        this.nestedNctNameRelationIndex = {};
        this.nestedDomainValueList = {};
        this.simpleDomainValueListByIndex = {};
    }
    DomainService.prototype.getDomains = function () {
        return __awaiter(this, void 0, void 0, function () {
            var customerInfo, rspMiscNena, rspMisc, rspJuris, handleJuris;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        customerInfo = this.userService.customerInfo;
                        return [4 /*yield*/, this.getNenaDomainMisc()];
                    case 1:
                        rspMiscNena = _a.sent();
                        rspMiscNena.data.domains.forEach(function (d) {
                            var colName = d.col_name.toLowerCase();
                            _this.simpleDomainValueListByIndex[colName] = d.list;
                        });
                        return [4 /*yield*/, this.getNagDomainsMisc()];
                    case 2:
                        rspMisc = _a.sent();
                        rspMisc.data.domains.forEach(function (d) {
                            if (!Array.isArray(d.list)) {
                                Object.keys(d.list).forEach(function (key) {
                                    var nctNameWithKey = d.nct_name + ':' + key;
                                    _this.simpleDomainValueListByIndex[nctNameWithKey] = d.list[key];
                                });
                            }
                            else {
                                _this.simpleDomainValueListByIndex[d.nct_name] = d.list;
                            }
                        });
                        return [4 /*yield*/, this.getNagDomainsJuris(customerInfo.givState)];
                    case 3:
                        rspJuris = _a.sent();
                        handleJuris = function (data, obj, parentNctName) {
                            if (!data.list) {
                                return;
                            }
                            var nctName = data.nct_name;
                            if (!Array.isArray(data.list)) {
                                Object.keys(data.list).forEach(function (key) {
                                    var nctNameWithKey = data.nct_name + ':' + key;
                                    handleJuris({
                                        nct_name: nctNameWithKey,
                                        name: data.name,
                                        list: data.list[key]
                                    }, obj, parentNctName);
                                });
                                return;
                            }
                            if (!_this.nestedNctNameRelationIndex[nctName]) {
                                _this.nestedNctNameRelationIndex[nctName] = {};
                            }
                            // Add parent relation
                            if (parentNctName) {
                                _this.nestedNctNameRelationIndex[nctName].parent = parentNctName;
                                // Add it as child relation for parent
                                if (!_this.nestedNctNameRelationIndex[parentNctName].children) {
                                    _this.nestedNctNameRelationIndex[parentNctName].children = [nctName];
                                }
                                else if (_this.nestedNctNameRelationIndex[parentNctName].children.indexOf(nctName) === -1) {
                                    _this.nestedNctNameRelationIndex[parentNctName].children.push(nctName);
                                }
                            }
                            if (data.list[0].nct_name) {
                                //
                                obj[nctName] = [];
                                data.list.forEach(function (i) {
                                    var children = {};
                                    obj[nctName].push({
                                        value: i.name,
                                        children: children
                                    });
                                    handleJuris(i, children, nctName);
                                });
                            }
                            else {
                                obj[nctName] = data.list;
                            }
                        };
                        if (rspJuris.data) {
                            this.nestedDomainValueList = {};
                            handleJuris(rspJuris.data, this.nestedDomainValueList);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DomainService.prototype.getNenaDomainMisc = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'admin/nenaDomainsMisc';
            _this.requestService.requestGet(url, {
                params: {
                    customerId: _this.userService.getCustomerIdByType()
                }
            }, function (rsp) {
                resolve(rsp);
            }, function (err) { return reject(err); });
        });
    };
    DomainService.prototype.getNagDomainsJuris = function (stateCode, counties) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'admin/nagDomainsJuris';
            var params = {
                state: stateCode,
            };
            if (counties) {
                params.counties = JSON.stringify(counties);
            }
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                resolve(rsp);
            }, function (err) { return reject(err); });
        });
    };
    DomainService.prototype.getNagDomainsMisc = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'admin/nagDomainsMisc';
            var params = {
                customerId: _this.userService.getCustomerIdByType()
            };
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                resolve(rsp);
            }, function (err) { return reject(err); });
        });
    };
    DomainService.prototype.getNagNeighbors = function (state, county) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'common/nagNeighbors';
            var params = {
                state: state
            };
            if (county) {
                params.county = county;
            }
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                resolve(rsp.data.neighbors);
            }, function (err) { return reject(err); });
        });
    };
    DomainService.prototype.calcNestedColumnRelationIndex = function (cols) {
        var _this = this;
        this.nestedColumnPropRelationIndex = {};
        cols.forEach(function (col) {
            if (!col.standard || !col.standard.valueDomainNameNct) {
                return;
            }
            var nctName = col.standard.valueDomainNameNct;
            var domainRelation = _this.nestedNctNameRelationIndex[nctName];
            if (!domainRelation) {
                return;
            }
            var relation = {
                nctName: nctName
            };
            var leftSuffix = '_l';
            var rightSuffix = '_r';
            var sideSuffix; // '_l', '_r'
            var find = function (nctName, sideSuffix) {
                var filtered = cols.filter(function (c) { return c.standard && c.standard.valueDomainNameNct === nctName; });
                if (!sideSuffix) {
                    return filtered[0];
                }
                else {
                    var sideCol = filtered.find(function (c) { return c.prop.toLowerCase().endsWith(sideSuffix); });
                    return sideCol || filtered[0];
                }
            };
            if (col.prop.toLowerCase().endsWith(leftSuffix)) {
                sideSuffix = leftSuffix;
            }
            else if (col.prop.toLowerCase().endsWith(rightSuffix)) {
                sideSuffix = rightSuffix;
            }
            if (domainRelation.parent) {
                var parentCol = find(domainRelation.parent, sideSuffix);
                if (parentCol) {
                    relation.parent = parentCol.prop;
                }
            }
            if (domainRelation.children) {
                relation.children = [];
                domainRelation.children.forEach(function (child) {
                    var childCol = find(child, sideSuffix);
                    if (childCol) {
                        relation.children.push(childCol.prop);
                    }
                });
            }
            _this.nestedColumnPropRelationIndex[col.prop] = relation;
        });
    };
    DomainService.prototype.getColumnDomains = function (cols, layerCateCode, rec) {
        var _this = this;
        if (!this.nestedColumnPropRelationIndex || !Object.keys(this.nestedColumnPropRelationIndex).length) {
            this.calcNestedColumnRelationIndex(cols);
        }
        var domainByCol = {};
        var layerCate = this.appinfoService.layerTypeList.find(function (i) { return i.code === layerCateCode; });
        var countyCol = (layerCate.colPrefix + '_' + this.attrIndexService.countyColNameStandard).toLowerCase();
        var countyLeftCol = countyCol + '_l';
        var countyRightCol = countyCol + '_r';
        if (!rec) {
            // Fake record with state and county
            rec = {};
            var stateCol = (layerCate.colPrefix + '_' + this.attrIndexService.stateColNameStandard).toLowerCase();
            var customerInfo = this.userService.customerInfo;
            var countyVal = customerInfo.cusCounties ? customerInfo.cusCounties[0] : null;
            var stateVal = customerInfo.givState;
            rec[countyCol] = countyVal;
            rec[stateCol] = stateVal;
            rec[countyLeftCol] = countyVal;
            rec[countyRightCol] = countyVal;
            rec[stateCol + '_l'] = stateVal;
            rec[stateCol + '_r'] = stateVal;
        }
        if (layerCate && layerCate.standardCols) {
            cols.forEach(function (col) {
                var standardCol = col.standard;
                if (!standardCol) {
                    return;
                }
                var domain = _this.getColumnDomain(col.prop, standardCol, layerCate, rec);
                if (domain) {
                    if ((col.prop === countyCol || col.prop === countyLeftCol || col.prop === countyRightCol) && _this.userService.customerInfo.cusCounties && _this.userService.customerInfo.cusCounties.length && domain.type === 'list') {
                        domain.list = domain.list.filter(function (i) { return _this.userService.customerInfo.cusCounties.indexOf(i) > -1; });
                    }
                    domainByCol[col.prop] = domain;
                }
            });
        }
        return domainByCol;
    };
    DomainService.prototype.getColumnDomain = function (colProp, standardCol, layerCate, rec) {
        var _this = this;
        if (!layerCate) {
            return;
        }
        var domain;
        var colPropWithoutPrefix = standardCol.colName.toLowerCase();
        var list = this.simpleDomainValueListByIndex[colPropWithoutPrefix];
        if (list) {
            domain = {
                type: 'list',
                list: list
            };
        }
        else if (standardCol.valueDomainNameNct) {
            var nctName = standardCol.valueDomainNameNct;
            list = list || this.simpleDomainValueListByIndex[nctName];
            if (!list && rec && this.nestedColumnPropRelationIndex[colProp]) {
                var tree_1 = [];
                var addToTree_1 = function (prop) {
                    var colRelation = _this.nestedColumnPropRelationIndex[prop];
                    tree_1.unshift({
                        nct: colRelation.nctName,
                        value: rec[prop]
                    });
                    if (colRelation.parent) {
                        addToTree_1(colRelation.parent);
                    }
                };
                addToTree_1(colProp);
                var nestedList = this.nestedDomainValueList[tree_1[0].nct];
                var _loop_1 = function (i) {
                    if (!nestedList) {
                        return "break";
                    }
                    var branch = tree_1[i];
                    if (branch.nct === nctName) {
                        list = typeof nestedList[0] === 'object' ? nestedList.map(function (i) { return i.value; }) : nestedList;
                        return "break";
                    }
                    else {
                        var next = nestedList.find(function (i) { return i.value === branch.value; });
                        if (!next) {
                            return "break";
                        }
                        nestedList = next.children[tree_1[i + 1].nct];
                    }
                };
                for (var i = 0; i < tree_1.length; i++) {
                    var state_1 = _loop_1(i);
                    if (state_1 === "break")
                        break;
                }
            }
            if (!list) {
                list = [];
            }
            domain = {
                type: 'list',
                list: list
            };
        }
        else if (standardCol.valuePattern) {
            domain = {
                type: 'pattern',
                pattern: standardCol.valuePattern
            };
        }
        else if (standardCol.valueRange) {
            domain = {
                type: 'range',
                range: standardCol.valueRange
            };
        }
        return domain;
    };
    DomainService.prototype.updateDependentDomains = function (domainsByColumn, changedCol, rec, layerCateCode) {
        var _this = this;
        var layerCate = this.appinfoService.layerTypeList.find(function (i) { return i.code === layerCateCode; });
        var standardCols = layerCate.standardCols;
        var standardCol = standardCols.find(function (c) { return c.colName === changedCol.standardName; });
        if (!standardCol.valueDomainNameNct) {
            return;
        }
        var update = function (nctName) {
            if (_this.nestedNctNameRelationIndex[nctName] && _this.nestedNctNameRelationIndex[nctName].children) {
                _this.nestedNctNameRelationIndex[nctName].children.forEach(function (childNctName) {
                    var childCol = standardCols.find(function (c) { return c.valueDomainNameNct === childNctName; });
                    if (childCol) {
                        var childColProp = (layerCate.colPrefix + '_' + childCol.colName).toLowerCase();
                        domainsByColumn[childColProp] = _this.getColumnDomain(childColProp, childCol, layerCate, rec);
                        if (childCol.valueDomainNameNct) {
                            update(childCol.valueDomainNameNct);
                        }
                    }
                });
            }
        };
        update(standardCol.valueDomainNameNct);
    };
    DomainService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DomainService_Factory() { return new DomainService(i0.ɵɵinject(i1.ActivityService), i0.ɵɵinject(i2.AppinfoService), i0.ɵɵinject(i3.AttrIndexService), i0.ɵɵinject(i4.CommonRequestService), i0.ɵɵinject(i5.UserService)); }, token: DomainService, providedIn: "root" });
    return DomainService;
}());
export { DomainService };
